module.exports = __webpack_public_path__ + "static/img/hx03.a9117ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hx03.png
// module id = M7fR
// module chunks = 0